import React from 'react';
import classnames from 'classnames';
import { IconTicket } from 'components/Icons';

export default function LoadingSpinner() {
  return (
    <div
      className={classnames({
        'syos-loader': true,
        'syos-loader--active': true,
      })}
    >
      <div className="syos-progress-bar" />
      <div className="syos-loader__content">
        <span className="syos-loader__message">
          <IconTicket />
          Loading seat availability...
        </span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/javascripts/components/LoadingSpinner.js